const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      const cartForms = document.querySelectorAll(
        ".cart-page, .cart-drawer__footer"
      );
      if (cartForms.length > 0) {
        initializeGiftWrapping();
      }
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

function initializeGiftWrapping() {
  const forms = document.querySelectorAll(".cart-page, .cart-drawer__footer");

  forms.forEach((cartForm) => {
    if (cartForm.dataset.giftWrapInitialized) {
      return;
    }

    const giftWrapCheckbox = cartForm.querySelector("#gift-wrap-checkbox");

    if (giftWrapCheckbox) {
      giftWrapCheckbox.addEventListener("change", (event) => {
        updateCartAttributes(cartForm);
      });
    }

    cartForm.dataset.giftWrapInitialized = "true";
  });
}

document.addEventListener("DOMContentLoaded", initializeGiftWrapping);

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}

const debouncedUpdate = debounce(
  (cartForm) => updateCartAttributes(cartForm),
  300
);

function updateCartAttributes(cartForm) {
  if (cartForm) {
    const formData = new FormData(cartForm);
    fetch(cartForm.action, {
      method: cartForm.method,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .catch((error) => {
        console.error("Error updating cart:", error);
      });
  }
}